import React, { useState } from "react";
import { PhoneNumber } from "../ui/PhoneNumber";
import logo from "../../assets/logo-2.png";
import Input from "../ui/Input";
import { CiMail } from "react-icons/ci";
import { validEmail } from "../../helper/appConstant";
import { useDispatch } from "react-redux";
import {
  checkEmailOrPhoneNumberExistOrNot,
  sentOtp,
} from "../../store/slice/auth";
import OtpDialog from "../dialogs/OtpDialog";
import { useNavigate } from "react-router-dom";
import ResetPassword from "./ResetPassword";
import Button from "component/ui/Button";

const ForgetPassword = () => {
  const navigate = useNavigate("");
  const dispatch = useDispatch();
  const [loginType, setLoginType] = useState("phone");
  const [formData, setFormData] = useState({});
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [focusedInput, setFocusedInput] = useState(null);
  const [showResetPassword, setShowResetPassword] = useState(false);

  const handleSendVerificationCode = () => {
    const data = {
      email: formData?.email || "",
      password: formData?.password,
      phoneNumber: formData?.phoneNumber || "",
      countryCode: formData?.phoneNumber ? formData?.countryCode : "",
      userType: [],
    };
    dispatch(sentOtp(data, setIsDialogOpen));
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    if (loginType == "email" && !formData?.email) {
      setFormData(() => ({
        ...formData,
        emailError: "Please enter email.",
      }));
      return;
    }
    if (
      loginType == "email" &&
      formData?.email &&
      !validEmail(formData?.email)
    ) {
      // setEmailError('Please enter valid email.');
      setFormData(() => ({
        ...formData,
        emailError: "Please enter valid email.",
      }));
      return;
    }
    if (loginType == "phone" && !formData?.phoneNumber) {
      setFormData(() => ({
        ...formData,
        phoneError: "Please enter phone number.",
      }));
      return;
    }

    handleSendVerificationCode();
  };

  const afterValidate = () => {
    // if (loginType == "email") {
    //   navigate(`/resetPassword?email=${formData?.email}`)
    // } else {
    //   navigate(`/resetPassword?phone=${formData?.phoneNumber}&countryCode=${formData?.countryCode}`)
    // }
    setShowResetPassword(true);
  };

  return showResetPassword ? (
    <ResetPassword searchParams={formData} />
  ) : (
    <div className="min-h-screen flex justify-center items-center bg-gradient-to-br from-gray-50 to-blue-50 p-4">
      <div className="w-full max-w-md bg-white shadow-xl rounded-lg md:p-8 p-3 relative">
        {/* Top Gradient Line */}
        <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#2BACE2] via-[#057BB5] to-[#2BACE2] rounded-t-xl"></div>

        {/* Logo */}
        <div className="flex justify-center mb-5">
          <img src={logo} alt="Logo" className="w-40" />
        </div>

        <h2 className="text-2xl font-semibold text-center text-gray-800">
          Forgot Password
        </h2>

        <p className="text-sm text-gray-500 text-center mt-2 md:mb-6 mb-2 md:px-4 px-2">
          Enter your registered phone number. We will send you a verification
          code to reset your password.
        </p>

        {/* Phone Number Component */}
        <div className="mt-4 mb-2">
          {loginType === "phone" && (
            <div className="space-y-4">
              <div>
                <PhoneNumber
                  placeholder="Phone number"
                  onChange={(val) =>
                    setFormData(() => ({
                      ...formData,
                      ...val,
                      phoneError: "",
                    }))
                  }
                  error={formData?.phoneError}
                />
              </div>
            </div>
          )}

          {loginType === "email" && (
            <div className="space-y-4">
              <div className="relative group">
                <Input
                  onFocus={() => setFocusedInput("email")}
                  onBlur={() => setFocusedInput(null)}
                  placeholder="your.email@example.com"
                  inputClassName="w-full pl-4 pr-12 py-3 placeholder:text-sm text-sm transition-all duration-300 bg-gray-50 hover:bg-white relative  "
                  onChange={(val) =>
                    setFormData(() => ({
                      ...formData,
                      email: val,
                      emailError: "",
                    }))
                  }
                  error={formData?.emailError}
                />
                <div
                  className={`absolute right-4 top-1/2 -translate-y-1/2 ${
                    focusedInput === "email"
                      ? "text-[#2BACE2]"
                      : "text-gray-400"
                  }`}
                >
                  <CiMail size={20} />
                </div>
              </div>
            </div>
          )}
        </div>

        <div className="flex justify-end mb-6">
          {loginType === "phone" ? (
            <button
              onClick={() => setLoginType("email")}
              className="text-[#2BACE2] md:text-sm text-xs md:font-semibold font-medium hover:underline"
            >
              Reset your password using Email
            </button>
          ) : (
            <button
              onClick={() => setLoginType("phone")}
              className="text-[#2BACE2] text-sm font-semibold hover:underline"
            >
              Reset your password using Phone Number
            </button>
          )}
        </div>

        {/* Submit Button */}

        <Button className="w-full" onClick={handleSubmit}>
          Sent OTP
        </Button>

        <p className="text-center mt-6 text-sm text-gray-700">
          Remember your password?{" "}
          <a
            onClick={() => navigate("/login")}
            className="text-[#2BACE2] font-semibold hover:underline cursor-pointer"
          >
            Log In
          </a>
        </p>
      </div>
      {isDialogOpen && (
        <OtpDialog
          isDialogOpen={isDialogOpen}
          closeDialog={() => setIsDialogOpen(false)}
          formData={formData}
          afterValidate={afterValidate}
          handleResend={handleSendVerificationCode}
        />
      )}
    </div>
  );
};

export default ForgetPassword;
